import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted : false,
    isTransactionSuccessfullyCompleted: false,
    isFirstInvoiceSelected: '',
    isConfirmationDialogOpen: false, 
    transactionId: '',
    searchValue: '',
    searchType: '',
    customerName: '',
    invoiceList: [],
    singleInvoice: {},
    isLoading: false
};

export const vodafoneInvoicesSlice = createSlice({
    name: 'vodafoneInvoices',
    initialState,
    reducers:{
        displayInvoiceList : (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        displaySingleInvoice : (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        displayMainUtilityView : (state) => 
        {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        changeConfirmationDialogState: (state) =>
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setSubscriberBalance: (state, action) => 
        {
            state.subscriberBalance = action.payload
        },
        setSearchValue: (state, action) => 
        {
            state.searchValue = action.payload
        },
        setSearchType: (state, action) => 
        {
            state.searchType = action.payload
        },
        setCustomerName : (state, action) => 
        {
            state.customerName = action.payload
        },
        setIsTransactionSuccessfullyStarted : (state, action) => 
        {
            state.isTransactionSuccessfullyStarted = action.payload
        },
        resetVodafoneInvoicesSlice: () => initialState

    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'ASBS/GetVodafoneInvoices')
                {         
                    state.invoiceList = action.payload.response.invoices.map(invoice => { 
                        return {displayInfo: { Data: invoice.InvoiceDate, Vlera: invoice.InvoiceTotalAmount}, detailedInfo: {Emri: invoice.CustomerName, Kodi: invoice.CustomerCode, Seriali: invoice.SerialNumber, Data: invoice.InvoiceDate, Vlera: invoice.InvoiceTotalAmount}}
                    })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false   
                }
                else if(action.payload.endpoint === 'ASBS/StartVodafoneInvoices')
                {         
                    state.isTransactionSuccessfullyStarted = true
                    state.transactionId = action.payload.response.transID
                }
                else if(action.payload.endpoint === 'ASBS/ConfirmVodafoneInvoices')
                {  
                    state.isTransactionSuccessfullyStarted = false 
                    state.isTransactionSuccessfullyCompleted = true    
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
            })
    },
})
export const { displayInvoiceList, displaySingleInvoice, resetVodafoneInvoicesSlice,displayMainUtilityView,setIsTransactionSuccessfullyStarted, changeConfirmationDialogState, setSearchValue, setSearchType, setCustomerName } = vodafoneInvoicesSlice.actions;

export const selectVodafoneInvoicesState = (state) => state.vodafoneInvoices;

export default vodafoneInvoicesSlice.reducer;

